import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";
import { useForm } from "react-hook-form";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { MuiButton } from "../../../components/mui";
import { StandardPage, StandardForm, StandardFormMainContent, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, MuiBox } from "../../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../../components/inputs';


function ShippingAddressForm({values, onChange, onSave, ...props}) {
	const [name, setName] = useState(values?.name ?? "");
	const [addressLabel, setAddressLabel] = useState(values?.addressLabel ?? "");

	useEffect(()=>{
		setName(values?.name);
		setAddressLabel(values?.addressLabel)
	},[values]);

	function onClose(){
		props.onClose();
	}

	function save() {
		onSave({
			shippingAddressId:values?.shippingAddressId,
			name:name,
			addressLabel:addressLabel
		})
	}

  return (
    <>
			<Dialog open={props.isOpen} onClose={onClose} disableEnforceFocus fullWidth>
				<DialogTitle>{t('shipping_address.form_title')}</DialogTitle>
					<DialogContent>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextField label={t('shipping_address.address_name')} value={name} onChange={setName}/>
								</MuiCol>
							</MuiRow>
							<br/>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextArea label={t('shipping_address.address_label')} value={addressLabel} onChange={setAddressLabel} />
								</MuiCol>
							</MuiRow>
					</DialogContent>
					<DialogActions>
						<MuiButton color="primary" variant="outlined" onClick={onClose}>{t("cancel")}</MuiButton>
						<MuiButton color="primary" onClick={save}>{t("save")}</MuiButton>
					</DialogActions>
			</Dialog>
    </>
  );
}

ShippingAddressForm.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(ShippingAddressForm);